import i18n from 'i18next';

export function getDeliveryTypeName(deliveryType: string) {
  return i18n.t(`global.delivery-type.${deliveryType}.label`);
}
